// submitSubscribeForm
function submitSubscribeForm($form, $resultElement) {
  $.ajax({
    type: "GET",
    url: $form.attr("action"),
    data: $form.serialize(),
    cache: false,
    dataType: "jsonp",
    jsonp: "c", // trigger MailChimp to return a JSONP response
    contentType: "application/json; charset=utf-8",

    error: function(error){
    },

    success: function(data){
      if (data.result != "success") {
        var message = data.msg || "Sorry. Unable to subscribe. Please try again later.";
        $resultElement.css("color", "#ff5f6a");

        if (data.msg && data.msg.indexOf("already subscribed") >= 0) {
          message = "You're already subscribed. Thank you.";
          $resultElement.css("color", "#ff5f6a");
        }

        $resultElement.html(message);

      } else {
        $resultElement.css("color", "#008000");
        $resultElement.html("Thank you!");
      }
    }
  });
}
// Turn the given MailChimp form into an ajax version of it.
  // If resultElement is given, the subscribe result is set as html to
  // that element.
  function ajaxMailChimpForm($form, $resultElement){

    // Hijack the submission. We'll submit the form manually.
    $form.submit(function(e) {
      e.preventDefault();

      if (!isValidEmail($form)) {
        var error =  "A valid email address must be provided.";
        $resultElement.html(error);
        $resultElement.css("color", "#ff5f6a");
      } else {
        $resultElement.css("color", "#ff5f6a");
        $resultElement.html("Subscribing...");
        submitSubscribeForm($form, $resultElement);
      }
    });
  }

// Validate the email address in the form
function isValidEmail($form) {

  // If email is empty, show error message.
  // contains just one @
  var email = $form.find("input[type='email']").val();
  if (!email || !email.length) {
    return false;
  } else if (email.indexOf("@") == -1) {
    return false;
  }

  return true;
}

function refreshCart(cart) {
  
  if(cart.item_count == 0) {
    
    $('.o-header__navbar__basket__total').text(cart.item_count);
    $('.o-header__navbar__basket__total').addClass('d-none');
    
  } else {
    $('.o-header__navbar__basket__total').text(cart.item_count);
    $('.o-header__navbar__basket__total').removeClass('d-none');

  }  
}
function addToCartSuccess() {
  $.get( "/cart?view=full", function( data ) {
    $('#cartPage').html(data);
    const observer = lozad();
    observer.observe();
  });
}
function updateItem(li,ip) {

  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: { line: li, quantity: ip },
    dataType: 'json',
    async: false,
  });
}


// DOM READY
//
//

$(document).ready(function(e){   
  
  var language = LangShopSDK.getCurrentLanguage();
  
  if($(window).width() <= 991) {
    if($('.announcement_bar').length){
      $('#top').css('top',$('.announcement_bar').outerHeight());
    }
  }
  
    var scroll = $(window).scrollTop();
  if (scroll > 0) {
        $('.o-header__navbar-container').addClass('o-header__navbar-container--scrolled');
    	$('.template-404 .o-header__navbar-container').css('position', 'fixed');
      	$('.o-announcement-bar').addClass('o-announcement-bar--scrolled');
    
    	let annoucementBarHeight = $('.o-announcement-bar').outerHeight() - 1;    
    	$('.o-header__navbar-container').css('top', annoucementBarHeight+'px');
    
  } else {
  
  		$('.o-header__navbar-container').removeClass('o-header__navbar-container--scrolled');
    	$('.template-404 .o-header__navbar-container').css('position', 'relative');
      	$('.o-announcement-bar').removeClass('o-announcement-bar--scrolled');
  }
  
    $(window).scroll(function (event) {
        var scroll = $(window).scrollTop();
        // Do something
      
      if (scroll > 0) {
        $('.o-header__navbar-container').addClass('o-header__navbar-container--scrolled');
        $('.template-404 .o-header__navbar-container').css('position', 'fixed');
      	$('.o-announcement-bar').addClass('o-announcement-bar--scrolled');
        
        let annoucementBarHeight = $('.o-announcement-bar').outerHeight() - 1;
        $('.o-header__navbar-container').css('top', annoucementBarHeight+'px');
        
      } else {
  
  		$('.o-header__navbar-container').removeClass('o-header__navbar-container--scrolled');
        $('.template-404 .o-header__navbar-container').css('position', 'relative');
      	$('.o-announcement-bar').removeClass('o-announcement-bar--scrolled');
  		}
      
    });

  
  let announceBarHeight = $('.o-announcement-bar').outerHeight();
  $('.o-header__navbar-container').css('top', announceBarHeight+'px');
  
  $(window).resize(function(){
  	$('.o-header__navbar-container').css('top', announceBarHeight+'px');
    
  });
  
  jQuery(function() {
    function close_accordion_section() {
      jQuery('.page-accordion-heading').removeClass('active');
      jQuery('.page-accordion-content').slideUp(300).removeClass('active');
    }
    jQuery('.page-accordion-heading').click(function(e) {
      var currentAttrValue = jQuery(this).data('id');
      if(jQuery(this).hasClass('active')) {
        close_accordion_section();
      }else {
        close_accordion_section();
        jQuery(this).addClass('active');
        console.log('#'+currentAttrValue);
        jQuery('.page_content #'+currentAttrValue).addClass('active').slideDown(300); 
      }
      e.preventDefault();
    });
  });
  jQuery(function() {
    function close_accordion_section() {
      jQuery('.accordion-heading').removeClass('active');
      jQuery('.accordion-content').slideUp(300).removeClass('active');
    }
    jQuery('.accordion-heading').click(function(e) {
      var currentAttrValue = jQuery(this).data('id');
      if(jQuery(this).hasClass('active')) {
        close_accordion_section();
      }else {
        close_accordion_section();
        jQuery(this).addClass('active');

        jQuery('#'+currentAttrValue).addClass('active').slideDown(300); 
      }
      e.preventDefault();
    });
  });

  $('body').on('mouseleave',function(){
    $('#get_popup').trigger('click');
  });
  
  ajaxMailChimpForm($("#newsletter-form-mailchimp"), $("#subscribe-result"));
  ajaxMailChimpForm($("#newsletter-form-mailchimp1"), $("#subscribe-result1"));

  
  $('body').on('click', '.grid__item .adjust',function(){

    var input = $(this).parent().find('input');
    var ip = parseInt(input.val());
    if($(this).hasClass('cart-plus')) {
      ip = ip + 1;
    } else {
      ip = ip - 1;
    }
    if(ip==0) {
      return false;
    }
    input.val(ip);


    var id = parseInt(input.attr('data-id'));
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: 'updates['+id+']='+ip,
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
      },
      success: function(data){
        addToCartSuccess();
        refreshCart(data);
        
        // gtm event
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
          'event': 'add_to_cart',
          });
      }
    });
  });
  

  $('body').on('click','.js_add-to-cart',function(e){
    e.preventDefault();



    var btn = $(this);
    var form = $(this).closest('form');
    
    var addToCartBtnText = 'ADD TO CART';
    if (language.code == 'es') {
      addToCartBtnText = 'Añadir al carrito';
    }
    if (language.code == 'de') {
      addToCartBtnText = 'Zum Warenkorb hinzufügen';
    }
    if (language.code == 'fr') {
      addToCartBtnText = ' Ajouter au panier';
    }

//     var now =  $.now();
//     form.find('.freeid').val(now); 
    btn.attr('disabled', 'disabled');
    btn.text('adding...');
    form.find('.error').remove();

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: form.serialize(),
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        form.append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
        btn.text(addToCartBtnText);
        btn.removeAttr('disabled');
      }
    }).done(function( data ) {
      $('div[data-popup="cart-success"] h3').text(data.title);
      $('div[data-popup="cart-success"]').addClass('popup-active');
      $('.overlay').addClass('popup-active');
      
      
      
      btn.text(addToCartBtnText);
      btn.removeAttr('disabled');
      $.getJSON('/cart.js', function(cart){

        refreshCart(cart);
        
        
        $('.o-header__navbar__basket__total').animate({
          width: '40px',
          height: '40px',
          fontSize: '22px',
          lineHeight: '40px'
          
        }, 150, function() {
            $('.o-header__navbar__basket__total').animate({
            width: '15px',
            height: '15px',
            fontSize: '12px',
            lineHeight: '16px'

          }, 150, function() {

          });
        });
        
        	// gtm event
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
          'event': 'add_to_cart',
          });
      });
    });
  });

  $("body").on('click', ".popup-closer,.keep_shop", function(e){
    e.preventDefault();
    var $parents = $('.popup-active').attr('data-popup');
    $(this).closest(".cs-popup").removeClass("popup-active");
    $('.overlay').removeClass("popup-active");
    var video =   document.getElementById($parents);
    if(video){
      video.pause();
    }
  });


  $(window).scroll(function(){
    if ($(this).scrollTop() > 100) {
      $('.top-sec').fadeIn();
    } else {
      $('.top-sec').fadeOut();
    }
  });


  $("a.s13-btn-2.w-button").on("click", function() {
    if(window.innerWidth > 767){
      var get_val =150;
    }else{
      var get_val = 0;
    }
    $('html, body').animate({scrollTop:$('#s7').position().top + get_val }, 'slow');
  });

  $("a.nav-link-2.w-nav-link.home_link").click(function(event) {
    event.preventDefault();
    if(window.innerWidth > 767){
      var get_val = 50;
    }else{
      var get_val = 0;
    }

    var href = $(this).data('href');
    //     console.log($(href).offset().top ,'a');
    $('html,body').animate({scrollTop:$(href).offset().top - get_val }, 1000);
    //     var fd = $(href).offset().top;

    //       $('html,body').animate({scrollTop:fd - get_val },  {
    //         easing: 'swing',
    //         duration: 50,
    //         complete: function(){ 
    //           $('html,body').animate({scrollTop:$(href).offset().top - get_val }, 2000);
    //         }
    //       });

  });
  
  // checkout
  $('.js_cart-checkout-btn').on('click', function(){
  	// gtm event
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
          'event': 'checkout',
          });
  });
  
  $('.js_popup-go-checkout').on('click', function(){
  	// gtm event
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
          'event': 'checkout',
          });
  });
  
  
  
    
  $("a.home_link.nav-link.o-header__navbar__nav-link").click(function(event) {
    event.preventDefault();
    if(window.innerWidth > 767){
      var get_val = 50;
    }else{
      var get_val = 0;
    }

    var href = $(this).data('href');
    //     console.log($(href).offset().top ,'a');
    $('html,body').animate({scrollTop:$(href).offset().top - get_val }, 1000);
    //     var fd = $(href).offset().top;

    //       $('html,body').animate({scrollTop:fd - get_val },  {
    //         easing: 'swing',
    //         duration: 50,
    //         complete: function(){ 
    //           $('html,body').animate({scrollTop:$(href).offset().top - get_val }, 2000);
    //         }
    //       });

  });

  if(window.location.href.indexOf("#") > -1){
    var href = window.location.href.split("#")[1];
    
    if ($('#'+href).length) {
      $('html,body').animate({scrollTop:$('#'+href).offset().top }, 1000);
    	window.history.pushState(' ', 'Title',  window.location.href.split("#")[0]);
    }
    
    
  }else{
  }


  jQuery(function() {
    function close_accordion_review() {
      jQuery('.review_accordion-heading').removeClass('active');
      jQuery('.review_accordion-content').slideUp(300).removeClass('active');
    }
    jQuery('.review_accordion-heading').click(function(e) {
      // Grab current anchor value
      $('.easyslider-item.easyslider-active').removeClass('easyslider-active');
      var currentAttrValue = jQuery(this).data('id');

      if(jQuery(this).hasClass('active')) {
        close_accordion_review();
      }else {
        close_accordion_review();

        // Add active class to section title
        jQuery(this).addClass('active');
        // Open up the hidden content panel

        jQuery('.review_accordion #'+currentAttrValue).addClass('active').slideDown(300); 
      }
      e.preventDefault();
    });
    $('.product-template .easyslider-anchor').click(function(){
      close_accordion_review();
    });
  });
  
  if($(window).width() < 767) { 
    var $docEl = $('html, body'),  
        $wrap = $('.noscroll'),
        scrollTop;


    var overlayClose = function() {
      $.unlockBody();
      $('body').removeClass('popupOpen');
    }
    var overlayOpen = function() {
      $('body').addClass('popupOpen');
      $.lockBody();
    }

    $.lockBody = function() {
      if(window.pageYOffset) {
        scrollTop = window.pageYOffset;

        $wrap.css({
          top: - (scrollTop)
        });
      }

      $docEl.css({
        height: "100%",
        overflow: "hidden"
      });
    }

    $.unlockBody = function() {
      $docEl.css({
        height: "",
        overflow: ""
      });

      $wrap.css({
        top: ''
      });

      window.scrollTo(0, scrollTop);
      window.setTimeout(function () {
        scrollTop = null;
      }, 0);

    }
  }

  let langStatus = false;

  $('.ls-sw-languages').click(function(e) {
    if (langStatus == false) {
      $('.ls-sw-languages-24492908 > .active').css({"border-bottom": "0", "border-radius": "4px 4px 0 0"})
      langStatus = true;
    } else {
      $('.ls-sw-languages-24492908 > .active').css({"border-bottom": "1px solid black", "border-radius": "4px"});
      langStatus = false;
    }
    //    return (this.tog = !this.tog) ? $('.ls-sw-languages-24492908 > .active').css({"border-bottom": "0", "border-radius": "4px 4px 0 0"}) : $('.ls-sw-languages-24492908 > .active').css({"border-bottom": "1px solid black", "border-radius": "4px"});
  });

  $('.ls-sw-languages')
      .mouseenter(function() {})
      .mouseleave(function() {
        $('.ls-sw-languages').addClass('ls-sw-closed');
        $('.ls-sw-languages-24492908 > .active').css({"border-bottom": "1px solid black", "border-radius": "4px"});
        langStatus = false;
  });
  

    const observer = lozad(); // lazy loads elements with default selector as '.lozad'
  observer.observe();
  $('.slider-nav__overlay__color').click(function(e) {
    e.preventDefault();
    $(this).parent().find('.slick-slide.slick-active').last().trigger('click');
  });
  
  $('body').on('click', 'a[data-href="#shopify-section-1588588359582"]', function(e) {
    

    e.preventDefault();
    
    // Get the hash. In this example, "#myDestinationAnchor".
    var targetSelector = $(this).data('href');   
    var $target = $(targetSelector);

    // Animate the scroll to the destination...
    $('html, body').animate(
        {
            scrollTop: $target.offset().top // Scroll to this location.
        }, {
            // Set the duration long enough to allow time
            // to lazy load the elements.
            duration: 2000,

            // At each animation step, check whether the target has moved.
            step: function( now, fx ) {

                // Where is the target now located on the page?
                // i.e. its location will change as images etc. are lazy loaded
                var newOffset = $target.offset().top;

                // If where we were originally planning to scroll to is not
                // the same as the new offset (newOffset) then change where
                // the animation is scrolling to (fx.end).
                if(fx.end !== newOffset)
                    fx.end = newOffset;
            }
        }
    );
});
  
  // lanshop hotfix
  
  setTimeout(function () {
    
    $('.ls-sw-languages-24492908').eq(1).prev('br').remove();
$('.ls-sw-languages-24492908').eq(1).hide();
$('.ls-sw-languages-2574671140').eq(1).hide();
    }, 2000);

  
  // home display box link
  
  $('.o-displaybox').not('.js-no-link').on('click', function(){
  	let link = $('a.o-displaybox__btn', $(this)).attr('href');
    window.location.href = "https://arfacemask.com"+link;
  });
  

// END DOM ready
}); 

$(window).resize(function(){
  if($(window).width() <= 991) {
    if($('.announcement_bar').length){
      $('#top').css('top',$('.announcement_bar').outerHeight());
    }
  }else{
    $('#top').css('top',0);
  }
});
